import { types } from '../../../constants/ActionTypes'

const initialState = {
  open: false,
  puzzleInfo: {
    type: '',
    selectedTurn: 0,
    level: '',
  }
}

const puzzleInfoDialog = (state = initialState, action) => {
  switch (action.type) {
    case types.puzzleInfoDialog.OPEN:
      return { ...state, open: true }
    case types.puzzleInfoDialog.CLOSE:
      return { ...state, open: false }
    case types.puzzleInfoDialog.INITIALIZE:
      return { ...state, puzzleInfo: { ...state.puzzleInfo, ...action.puzzleInfo } }
    case types.puzzleInfoDialog.CHANGED_TEXT:
      return { ...state, puzzleInfo: { ...state.puzzleInfo, [action.name]: action.text } }
    default:
      return state
  }
}

export default puzzleInfoDialog



// WEBPACK FOOTER //
// ./src/reducers/Common/RenjuBoardCard/PuzzleInfoDialog.js